import axios from 'axios';
import { env } from '../env';

import { IAssistantScript } from '@interfaces/assistantScript';

const { REACT_APP_API_URL } = env;

export default class AssistantScriptsService {
  static async getAssistantScripts(
    config: any = {},
  ): Promise<IAssistantScript[]> {
    const { data } = await axios.get(
      `${REACT_APP_API_URL}api/v2/assistant/scripts`,
      {
        ...config,
      },
    );

    return data;
  }
}
